import { Stack, Typography } from "@material-ui/core";
import "moment/locale/he"; // without this line, language is not imported
import {
  ViewAgenda,
  GridViewOutlined,
  ApartmentOutlined,
  MeetingRoomOutlined
} from "@material-ui/icons";
import { useTranslation } from "react-i18next";
import { Grid } from "@material-ui/core";
import { Variant } from "@material-ui/core/styles/createTypography";

export type RoomsFloorAndSqrMtrProps = {
  floor: number;
  children?: JSX.Element;
  roomsCount: number;
  areaSizeM2: number;
  plotSizeM2: number;
  displaySize?: "regular" | "small";
  verticalDisplay?: boolean;
};

export default function RoomsFloorAndSqrMtr({
  floor,
  children,
  roomsCount,
  plotSizeM2,
  areaSizeM2,
  verticalDisplay,
  displaySize = "small"
}: RoomsFloorAndSqrMtrProps): JSX.Element {
  const { t: translate } = useTranslation();

  const textVariant: Variant = displaySize === "small" ? "caption" : "body2";

  return (
    <Grid
      container
      sx={
        verticalDisplay
          ? {
              maxWidth: 128,
              flexDirection: {
                xs: "column",
                sm: "row"
              }
            }
          : {
              flexDirection: {
                xs: "row"
              }
            }
      }
      spacing={0.1}
      padding={0.1}
    >
      {children}

      {roomsCount > 0 && (
        <Grid item sx={{ px: 1 }}>
          <Stack
            direction="row"
            alignItems="center"
            spacing={0.1}
            title={translate<string>("listingsMatch.rooms")}
          >
            <MeetingRoomOutlined sx={{ color: "gray" }} />
            <Typography variant={textVariant}>{`${roomsCount} ${translate<string>(
              "listingsMatch.rooms"
            )}`}</Typography>
          </Stack>
        </Grid>
      )}

      {floor > 0 && (
        <Grid item sx={{ px: 1 }}>
          <Stack
            direction="row"
            alignItems="center"
            spacing={0.1}
            title={translate<string>("listingsMatch.floor")}
          >
            <ApartmentOutlined sx={{ color: "gray" }} />
            <Typography variant={textVariant}>{`${translate<string>(
              "listingsMatch.floor"
            )} ${floor}`}</Typography>
          </Stack>
        </Grid>
      )}

      {areaSizeM2 > 0 && (
        <Grid item sx={{ px: 1 }}>
          <Stack
            direction="row"
            alignItems="center"
            spacing={0.1}
            title={translate<string>("listingsMatch.sizeOfPropertyM2")}
          >
            <GridViewOutlined sx={{ color: "gray" }} />
            <Typography variant={textVariant}>{`${areaSizeM2} ${translate<string>(
              "listingsMatch.sqrMeter"
            )}`}</Typography>
          </Stack>
        </Grid>
      )}

      {plotSizeM2 > 0 && (
        <Grid item sx={{ px: 1 }}>
          <Stack
            direction="row"
            alignItems="center"
            spacing={0.1}
            title={translate<string>("listingsMatch.sizeOfPlotM2")}
          >
            <ViewAgenda sx={{ color: "gray" }} />
            <Typography variant={textVariant}>{`${plotSizeM2} ${translate<string>(
              "listingsMatch.sqrMeter"
            )}`}</Typography>
          </Stack>
        </Grid>
      )}
    </Grid>
  );
}
